import { TourStepEnum } from 'features/onboarding/enums';

export const getSidebarFeatureList = (isRecruiterCompany?: boolean) => {
  const sidebarFeatureList = [
    'Launch new assignment',
    'Create new worker',
    'Add new partners',
  ];

  return isRecruiterCompany
    ? ['Create new customer', ...sidebarFeatureList]
    : sidebarFeatureList;
};

export const getAccountSettingFeatureList = () => {
  return [
    'Edit Profile',
    'Update Banking and Entity information',
    'Track your onboarding status',
  ];
};

export const getDashboardFeatureList = (isRecruiterCompany?: boolean) => {
  const dashboardFeatureList = [
    'Active assignments data',
    'Timesheet status report',
    'Assignments ending soon',
    'Summary profit report',
  ];

  return isRecruiterCompany
    ? ['Customers', ...dashboardFeatureList]
    : dashboardFeatureList;
};

export const TOUR_STEPS = [
  TourStepEnum.AccountSettings,
  TourStepEnum.Sidebar,
  TourStepEnum.HomeDashboard,
  TourStepEnum.Congratulations,
];

export const DEFAULT_TOUR_STEP = TourStepEnum.AccountSettings;

export const getNextTourStep = (tourStep: TourStepEnum) => {
  const lastCompletedStepIndex = TOUR_STEPS.findIndex(
    (step) => step === tourStep,
  );

  return TOUR_STEPS[lastCompletedStepIndex + 1];
};
